import { ColGroupDef } from '@ag-grid-community/core';
import {
  AgGridHelperService,
  ProductColGroupId,
} from '@products/fund-listing/services/ag-grid-helper.service';
import { TranslateService } from '@shared/translate/translate.service';
import { SuppressDetails } from '@types';
import { FundListingPerformanceController } from '../controllers/fund-listing-performance.controller';

/**
 * Return performance column definitions for US 529 Portfolios.
 * @param listingController ppss tab component
 * @param state ppss service state
 * @param agGridHelperService ag grid helper service instance
 */
export function getPerformanceColumnDefsForUS_529(
  listingController: FundListingPerformanceController,
  suppressDetails: SuppressDetails,
  agGridHelperService: AgGridHelperService,
  translateService: TranslateService
): ColGroupDef[] {
  const colGroupDefs: ColGroupDef[] = [
    {
      groupId: ProductColGroupId.FUND,
      headerGroupComponent: 'calcTypeGroupHeaderComponent',
      headerGroupComponentParams: listingController,
      children: [
        agGridHelperService.getFavFundColDef(listingController),
        agGridHelperService.getFundNameColDef(
          false,
          null,
          listingController.productType
        ),
        agGridHelperService.getShareClassNameColDef(listingController),
      ],
    },
    {
      groupId: ProductColGroupId.NAV,
      headerGroupComponent: 'dateGroupHeaderComponent',
      headerGroupComponentParams: {
        asOfDateText: () => listingController.navAsOfDate,
      },
      children: [
        agGridHelperService.getNavValueColDef(listingController),
        agGridHelperService.getNavChangeValueColDef(listingController),
        agGridHelperService.getNavYTDReturnColDef(listingController, {
          headerName: translateService.instant(
            'products.ytd-total-returns-nav'
          ),
          width: 80,
        }),
      ],
    },
    {
      groupId: ProductColGroupId.PERFORMANCE,
      headerGroupComponent: 'performanceGroupHeaderComponent',
      headerGroupComponentParams: listingController,
      children: [
        agGridHelperService.getAvgAnnualMonthly1YrColDef(
          listingController,
          suppressDetails,
          {
            width: 90,
          }
        ),
        agGridHelperService.getAvgAnnualMonthly3YrColDef(listingController, {
          width: 90,
        }),
        agGridHelperService.getAvgAnnualMonthly5YrColDef(listingController, {
          width: 90,
        }),
        agGridHelperService.getAvgAnnualMonthly10YrColDef(listingController, {
          width: 90,
        }),
        agGridHelperService.getAvgAnnualMonthlyInceptionColDef(
          listingController,
          suppressDetails
        ),
        agGridHelperService.getAvgAnnualQuarterly1YrColDef(
          listingController,
          suppressDetails,
          {
            width: 90,
          }
        ),
        agGridHelperService.getAvgAnnualQuarterly3YrColDef(listingController, {
          width: 90,
        }),
        agGridHelperService.getAvgAnnualQuarterly5YrColDef(listingController, {
          width: 90,
        }),
        agGridHelperService.getAvgAnnualQuarterly10YrColDef(listingController, {
          width: 90,
        }),
        agGridHelperService.getAvgAnnualQuarterlyInceptionColDef(
          listingController,
          suppressDetails
        ),
        agGridHelperService.getTotalAnnualOperatingExpensesColDef(
          listingController,
          {
            width: 115,
            headerName: translateService.instant(
              'products.total-asset-based-fees'
            ),
          }
        ),
      ],
    },
  ];
  return colGroupDefs;
}
